import queryString from "query-string";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import AclAction from "../../../Components/ACL/AclAction";
import CustomDropdownList from "../../../Components/CustomDropdownList";
import CustomReactTooltip from "../../../Components/CustomReactTooltip";
import DialogNew from "../../../Components/DialogNew";
import DynamicTableComponentNew from "../../../Components/DynamicTableComponentsNew";
import Search from "../../../Components/Search";
import { MasterServices } from "../../../Services/Master";
import ComapnyDetailsDateTimeFormatter from "../../../Utils/ComapnyDetailsDateTimeFormatter";
import constants from "../../../Utils/constants";
import CustomCloneDeep from "../../../Utils/CustomCloneDeep";
import Slugify from "../../../Utils/Slugify";
import Toast from "../../../Utils/Toast";
import isRole_Acc_mgr_or_salesAdmin from "../../../Utils/isRole_Acc_mgr_or_salesAdmin";

const tableHeader = [
  {
    id: "name",
    title: "name",
    sortable: true,
    headerStyle: {
      textTransform: "capitalize",
      textAlign: "left",
    },
    rowStyle: {
      textTransform: "capitalize",
      textAlign: "left",
    },
    visibility: true,
  },
  {
    id: "metric_type",
    title: "Metric Type",
    sortable: false,
    headerStyle: {
      textTransform: "capitalize",
      textAlign: "left",
    },
    rowStyle: {
      textTransform: "capitalize",
      textAlign: "left",
    },
    visibility: true,
  },
  {
    id: "metric_unit",
    title: "Metric Unit",
    sortable: false,
    headerStyle: {
      textTransform: "capitalize",
      textAlign: "left",
    },
    rowStyle: {
      textTransform: "capitalize",
      textAlign: "left",
    },
    visibility: true,
  },
  {
    id: "created_by",
    title: "Created By",
    sortable: false,
    headerStyle: { textTransform: "capitalize", textAlign: "left" },
    rowStyle: { textTransform: "capitalize", textAlign: "left" },
    visibility: true,
  },
  {
    id: "created_at",
    title: "Created On",
    sortable: true,
    headerStyle: { textAlign: "left" },
    rowStyle: { textAlign: "left" },
    visibility: true,
  },
  {
    id: "priority",
    title: "Priority",
    sortable: true,
    headerStyle: { textAlign: "left" },
    rowStyle: { textAlign: "left" },
    visibility: true,
  },
  {
    id: "is_active",
    title: "Status",
    sortable: true,
    headerStyle: {},
    rowStyle: { textAlign: "center" },
    headerClass: "text-center",
    visibility: true,
  },
  {
    id: "actions",
    title: "Actions",
    sortable: false,
    headerStyle: {},
    rowStyle: { textAlign: "center" },
    headerClass: "text-center",
    visibility: true,
  },
];
const showActions = false;
class ListMetrics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      sortColumn: constants.PAGINATION.DEFAULT_SORT_COLUMN,
      sortOrder: constants.PAGINATION.DEFAULT_SORT_ORDER,
      pageNo: this.props.pageNo,
      pageSize: this.props.pageSize,
      name: "",
      metricTypeName: "",
      selectedMetricTypeId: null,
      selectedMetricUnitId: null,
      metricTypeId: null,
      documentModal: false,
      apiError: null,
      formErrors: {},
      isFormSubmitted: false,
      dialogModal: false,
      dialogModalContent: "",
      dialogModalHeader: "",
      dialogModalConfig: {},
      dialogModalStyleType: "",
      typeDropdown: [],
      metricTypes: [],
      metricUnits: [],
      isEdit: false,
      metricId: null,
      currentPageDataCount: 0,
      disableStatus: false,
      metricsArray: [{ name: "", priority: 100 }],
      metricsTypeDropDown: [],
      metricUnitsDropDown: [],
      metricUnitId: null,
      editMetricName: "",
      editPriority: null,
    };
  }
  // Called once component is mounted
  componentDidMount() {
    const { search } = this.props.location;
    const { role_id } = this.props.home.loginUserSuccess;
    const params = queryString.parse(search);

    // Set initial metricTypeId and then fetch data
    this.setState(
      {
        metricTypeId: params.metric_type_id || "all",
        metricUnitId: params.metric_unit_id || "all",
      },
      () => {
        this.getMetricTypes();
        this.getMetricUnits();
        this.getTableData();
      },
    );

    // Role-based visibility for 'actions' column
    const actionColumnIndex = tableHeader.findIndex(col => col.id === "actions");
    const isRestrictedRole = isRole_Acc_mgr_or_salesAdmin(role_id);

    if (actionColumnIndex > -1) {
      tableHeader[actionColumnIndex].visibility = !isRestrictedRole;
    }

    if (isRestrictedRole) {
      this.setState({ disableStatus: true });
    }
  }

  // Pagination handlers
  pagePrevious = () => {
    this.setState(prev => ({ pageNo: prev.pageNo - 1 }), this.getTableData);
  };

  pageNext = () => {
    this.setState(prev => ({ pageNo: prev.pageNo + 1 }), this.getTableData);
  };

  handlePage = pageNo => {
    this.setState({ pageNo }, this.getTableData);
  };

  // Sorting handler
  handleSort = column => {
    this.setState(
      prev => ({
        sortColumn: column,
        segmentSort: false,
        sortOrder: prev.sortOrder === "desc" ? "asc" : "desc",
      }),
      this.getTableData,
    );
  };

  // Search reset to first page
  handleSearch = () => {
    this.setState({ pageNo: 1 }, this.getTableData);
  };

  // Metric (de)activation modal handler
  toggleMetricConfirmationHandler = data => {
    const isActive = data.is_active === true || data.is_active === 1;

    this.setState({
      dialogModal: true,
      dialogModalHeader: (
        <h3 className="text-darkblue2 font-weight-bold">{isActive ? "De-Activation" : "Activation"}</h3>
      ),
      dialogModalContent: (
        <div className={isActive ? "remove-body" : "activate-body"}>
          <h2 className="font-weight-semibold mb-0">
            {isActive
              ? constants.MASTER_DATA_METRIC.INACTIVATE_METRIC_CONFIRM_MESSAGE
              : constants.MASTER_DATA_METRIC.ACTIVATE_METRIC_CONFIRM_MESSAGE}
          </h2>
        </div>
      ),
      dialogModalConfig: {
        type: isActive ? "de-activate_metric" : "activate_metric",
        id: data.id,
      },
      dialogModalStyleType: isActive ? "danger-modal" : "success-modal",
    });
  };

  // Render actions column (e.g., Edit button)
  getActions = data => (
    <AclAction
      type={constants.ACL.PERMISSION_KEY}
      entity={constants.ACL.METRIC_DATA_RESOURCE.TITLE}
      action={constants.ACL.METRIC_DATA_RESOURCE.ACTIONS.EDIT}
    >
      <button
        tbrentitytype={constants.ACL.ENTITY_TYPE.BUTTON}
        id={`tooltip-${Slugify(constants.APPLICATION_ROUTE.MASTER_DATA_METRIC.LIST.EDIT_METRIC_TOOLTIP)}-${data.id}`}
        onClick={e => this.rowAction(constants.APPLICATION_ROUTE.MASTER_DATA_METRIC.LIST.EDIT_METRIC, data, e)}
        className="dynamicTableActionButton btn btn-md d-inline-flex align-items-center"
        data-for={`tooltip-${Slugify(
          constants.APPLICATION_ROUTE.MASTER_DATA_METRIC.LIST.EDIT_METRIC_TOOLTIP,
        )}-${data.id}`}
        data-tip={constants.APPLICATION_ROUTE.MASTER_DATA_METRIC.LIST.EDIT_METRIC_TOOLTIP}
        data-iscapture="true"
      >
        <span className="material-icons-outlined text-blue-clr icon-fs-20" style={{ marginLeft: "60px" }}>
          edit
        </span>
      </button>
    </AclAction>
  );

  // Fetch paginated/sorted/searched data
  getTableData = () => {
    const { pageNo, pageSize, sortOrder, sortColumn, name, metricTypeId, metricUnitId } = this.state;
    const { selectedTab, location, history } = this.props;

    // Build query string
    let queryParams = "";
    if (sortOrder) queryParams += `&sort_order=${sortOrder}&sort_column=${sortColumn}`;
    if (name) queryParams += `&search_column=name&search_value=${name}`;
    if (selectedTab) queryParams += `&selected_tab=${selectedTab}`;
    if (metricTypeId && metricTypeId !== "all" && metricTypeId !== "undefined") {
      queryParams += `&metric_type_id=${metricTypeId}`;
    }

    if (metricUnitId && metricUnitId !== "all" && metricUnitId !== "undefined") {
      queryParams += `&metric_unit_id=${metricUnitId}`;
    }

    // Push URL with updated params
    history.push({
      pathname: location.pathname,
      search: `?page=${pageNo}&page_size=${pageSize}${queryParams}`,
    });

    // API call
    MasterServices.getTotalMetrics(`metrics/list?level=2&page=${pageNo}&page_size=${pageSize}${queryParams}`)
      .then(res => {
        const { rows = [], count = 0 } = res.data.data;
        const metricData = rows.map(data => ({
          id: data.id,
          name: data.name || "-",
          metric_type: data.parent_data?.name || "-",
          metric_unit: data.metric_unit?.name || "-",
          created_by: data.created_by_user
            ? `${data.created_by_user.first_name} ${data.created_by_user.last_name}`
            : "-",
          created_at: ComapnyDetailsDateTimeFormatter(data.created_at || new Date(), false),
          priority: data.priority || "-",
          is_active: this.renderToggle(data),
          actions: this.getActions(data),
        }));

        this.setState({
          rowData: metricData,
          count,
          currentPageDataCount: metricData.length,
        });
      })
      .catch(error => {
        this.setState({ rowData: [], count: 0 });
        Toast(error?.data?.error || constants.ERROR.SOMETHING_WENT_WRONG, "error");
      });
  };

  // Render toggle switch with access control
  renderToggle = data => {
    const isActive = data.is_active === true || data.is_active === 1;

    return (
      <AclAction
        type={constants.ACL.PERMISSION_KEY}
        entity={constants.ACL.METRIC_DATA_RESOURCE.TITLE}
        action={constants.ACL.METRIC_DATA_RESOURCE.ACTIONS.STATUS}
      >
        <div className="custom-control custom-switch success-toggle">
          <input
            type="checkbox"
            className="custom-control-input"
            id={`customSwitch${data.id}`}
            checked={isActive}
            onChange={e => {
              e.stopPropagation();
              this.rowAction(constants.APPLICATION_ROUTE.MASTER_DATA_METRIC.LIST.STATUS, data, e);
            }}
            disabled={this.state.disableStatus}
          />
          <label className="custom-control-label" htmlFor={`customSwitch${data.id}`}></label>
        </div>
      </AclAction>
    );
  };

  // Page size change handler
  handlePageSize = e => {
    this.setState({ pageSize: e.target.value, pageNo: 1 }, this.getTableData);
  };

  // Input search value handler
  handleInput = e => {
    this.setState({ name: e.target.value });
  };
  // Opens the metric modal for creating a new metric
  addMetric = () => {
    this.setState({ documentModal: true });
  };

  // Closes the metric modal and resets form states
  closeDocumentModal = () => {
    const updatedDropdown = this.state.metricsTypeDropDown.map(r => ({
      ...r,
      is_selected: false,
    }));

    const updatedMetricUnitsDropDown = this.state.metricUnitsDropDown.map(r => ({
      ...r,
      is_selected: false,
    }));

    this.setState({
      documentModal: false,
      metricsTypeDropDown: updatedDropdown,
      metricUnitsDropDown: updatedMetricUnitsDropDown,
      metricTypeName: "",
      priority: null,
      isEdit: false,
      formErrors: {},
      metricId: null,
      metricsArray: [{ name: "", priority: 100 }],
      editMetricName: "",
      editPriority: null,
    });
  };

  // Activates or deactivates a metric type
  toggleMetric = (id, isActive) => {
    MasterServices.activeInactiveMetricType(id, { is_active: isActive })
      .then(() => {
        Toast(
          isActive ? constants.MASTER_DATA_METRIC.ACTIVATE.SUCCESS : constants.MASTER_DATA_METRIC.IN_ACTIVATE.SUCCESS,
          "success",
        );
        this.getTableData();
      })
      .catch(error => {
        Toast(error?.data?.error || constants.ERROR.SOMETHING_WENT_WRONG, "error");
      });
  };

  // Handles confirmation actions from dialog modal
  dialogModalAccept = ({ type, id }) => {
    this.setState({
      dialogModal: false,
      dialogModalHeader: "",
      dialogModalContent: "",
      dialogModalConfig: {},
    });

    if (type === "de-activate_metric") this.toggleMetric(id, 0);
    else if (type === "activate_metric") this.toggleMetric(id, 1);
  };

  // Handles dialog modal decline (cancel)
  dialogModalDecline = () => {
    this.setState({
      dialogModal: false,
      dialogModalHeader: "",
      dialogModalContent: "",
      dialogModalConfig: {},
    });
  };

  // Opens modal to edit a metric and pre-fills the form
  editMetricConfirmationHandler = data => {
    const updatedDropdown = this.state.metricsTypeDropDown.map(t => ({
      ...t,
      is_selected: t.id === data.parent_id,
    }));
    const updatedUnitDropdown = this.state.metricUnitsDropDown.map(t => ({
      ...t,
      is_selected: t.id === data.metric_unit_id,
    }));

    this.setState({
      documentModal: true,
      isEdit: true,
      selectedMetricTypeId: data.parent_id,
      metricTypeName: data.name,
      editMetricName: data.name,
      editPriority: data.priority,
      metricsTypeDropDown: updatedDropdown,
      metricUnitsDropDown: updatedUnitDropdown,
      metricId: data.id,
      selectedMetricUnitId: data.metric_unit_id,
    });
  };

  // Delegates action button logic for each row
  rowAction = (action, data, e) => {
    e.stopPropagation();

    if (action === constants.APPLICATION_ROUTE.MASTER_DATA_METRIC.LIST.STATUS) {
      this.toggleMetricConfirmationHandler(data);
    } else if (action === constants.APPLICATION_ROUTE.MASTER_DATA_METRIC.LIST.EDIT_METRIC) {
      this.editMetricConfirmationHandler(data);
    }
  };

  // Fetches all metric types for dropdown and sets default selections
  getMetricTypes = () => {
    MasterServices.getTotalMetricTypes("metrics/list")
      .then(res => {
        const response = res?.data?.data?.rows || [];
        const sorted = response.sort((a, b) => a.name.localeCompare(b.name));

        const metricsTypeDropDown = CustomCloneDeep(sorted);
        const totalMetricTypes = [{ id: "all", name: "All Metric Types" }, ...sorted].map(r => ({
          ...r,
          is_selected: r.id === parseInt(this.state.metricTypeId),
        }));
        this.setState({
          metricTypes: totalMetricTypes,
          metricsTypeDropDown,
        });
      })
      .catch(error => {
        Toast(error?.data?.error || constants.ERROR.SOMETHING_WENT_WRONG, "error");
      });
  };

  getMetricUnits = () => {
    MasterServices.getTotalMetricUnits(`metrics-unit/list`)
      .then(res => {
        const response = res?.data?.data?.rows || [];
        const sorted = response.sort((a, b) => a.name.localeCompare(b.name));

        const metricUnitsDropDown = CustomCloneDeep(sorted);
        const totalMetricUnits = [{ id: "all", name: "All Metric Units" }, ...sorted].map(r => ({
          ...r,
          is_selected: r.id === parseInt(this.state.metricUnitId),
        }));
        this.setState({
          metricUnits: totalMetricUnits,
          metricUnitsDropDown,
        });
      })
      .catch(error => {
        Toast(error?.data?.error || constants.ERROR.SOMETHING_WENT_WRONG, "error");
      });
  };

  // Updates selected metric type in create/edit form
  handleTypeChange = e => {
    const updated = this.state.metricsTypeDropDown.map(t => ({
      ...t,
      is_selected: t.id === e.id,
    }));

    this.setState({
      selectedMetricTypeId: e.id,
      metricsTypeDropDown: updated,
      formErrors: { ...this.state.formErrors, metricTypeIdError: false },
    });
  };

  // Updates filter dropdown and reloads metric list
  handleTypeChangeFilter = e => {
    const updated = this.state.metricTypes.map(t => ({
      ...t,
      is_selected: t.id === e.id,
    }));

    this.setState({ metricTypeId: e.id, pageNo: 1, metricTypes: updated }, this.getTableData);
  };

  // Validates the form and flags errors
  isFormValid = () => {
    const { selectedMetricTypeId, selectedMetricUnitId, metricsArray, editMetricName, metricId } = this.state;

    const metricTypeIdError = !selectedMetricTypeId;
    const metricsArrayError = !metricId && metricsArray.filter(r => r.name.trim() === "").length > 0;
    const editMetricNameError = metricId && editMetricName.trim() === "";

    const formError = metricTypeIdError || metricsArrayError || editMetricNameError;

    this.setState({
      formErrors: {
        ...this.state.formErrors,
        metricTypeIdError,
        metricsArrayError,
        editMetricNameError,
      },
      apiError: null,
    });

    return formError;
  };

  // Handles form submission for creating a new metric
  handleSubmit = e => {
    e.preventDefault();
    if (this.isFormValid()) return;

    const { selectedMetricTypeId, metricsArray, selectedMetricUnitId } = this.state;
    const input = {
      parent_id: selectedMetricTypeId,
      metrics_data: metricsArray,
      metric_unit_id: selectedMetricUnitId,
    };

    MasterServices.addMetrics(input)
      .then(() => {
        this.closeDocumentModal();
        Toast(constants.MASTER_DATA_METRIC.CREATE.SUCCESS, "success");
        this.getTableData();
      })
      .catch(error => {
        Toast(error?.data?.error || constants.ERROR.SOMETHING_WENT_WRONG, "error");
      });
  };

  // Handles form submission for editing an existing metric
  handleEditSubmit = (e, metricId) => {
    e.preventDefault();
    if (this.isFormValid()) return;

    const { editMetricName, selectedMetricTypeId, editPriority, selectedMetricUnitId } = this.state;

    const data = {
      name: editMetricName,
      parent_id: selectedMetricTypeId,
      priority: editPriority,
      metric_unit_id: selectedMetricUnitId,
    };

    MasterServices.updateMetrics(metricId, data)
      .then(() => {
        this.closeDocumentModal();
        Toast(constants.MASTER_DATA_METRIC.EDIT.SUCCESS, "success");
        this.getTableData();
      })
      .catch(error => {
        Toast(error?.data?.error || constants.ERROR.SOMETHING_WENT_WRONG, "error");
      });
  };

  // Handles changes to input fields and triggers validation
  handleInputChange = e => {
    const { name, value } = e.target;
    this.setState(
      {
        [name]: value,
        formErrors: { ...this.state.formErrors, metricNameError: false },
      },
      () => {
        this.setState({ isFormSubmitted: true });
        this.isFormValid();
      },
    );
  };

  handleMetricUnitChange = e => {
    const updated = this.state.metricUnitsDropDown.map(t => ({
      ...t,
      is_selected: t.id === e.id,
    }));

    this.setState({
      selectedMetricUnitId: e.id,
      metricUnitsDropDown: updated,
      formErrors: { ...this.state.formErrors, metricUnitIdError: false },
    });
  };

  handleMetricUnitChangeFilter = e => {
    const updated = this.state.metricUnits.map(t => ({
      ...t,
      is_selected: t.id === e.id,
    }));

    this.setState({ metricUnitId: e.id, pageNo: 1, metricUnits: updated }, this.getTableData);
  };

  render() {
    return (
      <>
        <div className="row align-items-center">
          <div className="col-md-3 col-sm-6 mb-3 col-lg-3 position-relative">
            <div className="border-search search-box-shadow-2">
              <Search
                handleSearch={this.handleSearch}
                handleInput={this.handleInput}
                value={this.state.name}
                placeHolder={"Filter Metric"}
              />
            </div>
          </div>
          {this.state.metricTypes && this.state.metricTypes.length > 0 && (
            <div className="col-md-3 col-sm-6 mb-3 col-lg-3 clients_dropdown position-relative">
              <div className="custom-combobox-list">
                <CustomDropdownList
                  data={this.state.metricTypes}
                  handleChange={this.handleTypeChangeFilter}
                  placeholder={"Filter Metric Type"}
                  valueField={"id"}
                  textField={"name"}
                />
              </div>
            </div>
          )}

          {this.state.metricUnits && this.state.metricUnits.length > 0 && (
            <div className="col-md-3 col-sm-6 mb-3 col-lg-3 clients_dropdown position-relative">
              <div className="custom-combobox-list">
                <CustomDropdownList
                  data={this.state.metricUnits}
                  handleChange={this.handleMetricUnitChangeFilter}
                  placeholder={"Filter Metric Unit"}
                  valueField={"id"}
                  textField={"name"}
                />
              </div>
            </div>
          )}

          <div className="d-flex justify-content-end align-self-end flex-wrap ml-auto col">
            <AclAction
              type="permissions"
              entity={constants.ACL.METRIC_DATA_RESOURCE.TITLE}
              action={constants.ACL.METRIC_DATA_RESOURCE.ACTIONS.CREATE}
            >
              <div tbrentitytype={constants.ACL.ENTITY_TYPE.DIV} className="">
                <button
                  className={"btn btn-custom btn-primary icon-text-btn title-btn d-inline-flex align-items-center mb-3"}
                  type="button"
                  onClick={this.addMetric}
                >
                  <span className="material-icons-round icon-fs-16 mr-1">add</span>
                  {" " + constants.APPLICATION_ROUTE.MASTER_DATA_METRIC.LIST.ADD_BUTTON_TITLE}
                </button>
              </div>
            </AclAction>
          </div>
        </div>
        <div className="custom-table-block custom-table-block-2 first-col-fixed-block last-iconcol-fixed-block nowrap-table-block th-nowrap sort-table-block center-th-align">
          <DynamicTableComponentNew
            columnData={tableHeader}
            rowData={this.state.rowData}
            pagePrevious={this.pagePrevious}
            pageNext={this.pageNext}
            pageSize={this.state.pageSize}
            pageNo={this.state.pageNo}
            handlePage={this.handlePage}
            handleSort={this.handleSort}
            sortColumn={this.state.sortColumn}
            sortOrder={this.state.sortOrder}
            count={this.state.count}
            rowAction={this.rowAction}
            colSpan={tableHeader.filter(h => h.visibility).length}
            showActions={showActions}
            showPagination={true}
            paginationClass={"center-pagination custom-pagination-new"}
            handlePageSize={this.handlePageSize}
          />
        </div>

        {/* Tooltips for icons in table, don't delete */}
        {this.state.rowData.map(data => {
          return (
            <>
              <CustomReactTooltip
                id={`tooltip-${Slugify(
                  constants.APPLICATION_ROUTE.MASTER_DATA_METRIC.LIST.EDIT_METRIC_TOOLTIP,
                )}-${data.id}`}
                multiline={true}
              />
            </>
          );
        })}
        <Modal
          isOpen={this.state.documentModal}
          toggle={this.closeDocumentModal}
          className={"modal-sm modal-w-header custom-modal modal-without-header primary-modal"}
        >
          <ModalHeader toggle={this.closeDocumentModal}>{this.state.isEdit ? "Edit Metric" : "Add Metric"}</ModalHeader>
          <ModalBody>
            <div className={"row"}>
              <div className="col-lg-12 col-sm-12 form-group position-relative ml-auto mr-auto">
                <label for="companies">
                  Metric Type <span className={"mandatory"}>* </span>
                </label>
                <div className={`${this.state.formErrors.metricTypeIdError ? "is-invalid" : ""} custom-combobox-list`}>
                  <CustomDropdownList
                    data={this.state.metricsTypeDropDown}
                    handleChange={this.handleTypeChange}
                    placeholder={"Select Metric Type"}
                    valueField={"id"}
                    textField={"name"}
                  />
                </div>
                {this.state.formErrors.metricTypeIdError && (
                  <div className="invalid-tooltip d-block">{constants.FORM.MANDATORY_FIELD}</div>
                )}
              </div>

              <div className="col-lg-12 col-sm-12 form-group position-relative ml-auto mr-auto">
                <label for="companies">Metric Unit</label>
                <div className="custom-combobox-list">
                  <CustomDropdownList
                    data={this.state.metricUnitsDropDown}
                    handleChange={this.handleMetricUnitChange}
                    placeholder={"Select Metric Unit"}
                    valueField={"id"}
                    textField={"name"}
                  />
                </div>
              </div>

              <div className="col-lg-12 col-sm-12 position-relative ml-auto mr-auto d-flex">
                <div style={{ width: "70%" }}>
                  <label>
                    Metric Name <span className={"mandatory"}>* </span>
                  </label>
                </div>
                <div style={{ width: "30%" }}>
                  <label>Select Priority</label>
                </div>
              </div>
              {this.state.metricId !== null ? (
                <div
                  className="d-flex g-10 justify-content-between"
                  style={{
                    padding: "0px 16px",
                    width: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <input
                      type="text"
                      name="metricName"
                      placeholder="Enter Metric Name"
                      className={`form-control ${this.state.formErrors.editMetricNameError ? "is-invalid" : ""}`}
                      value={this.state.editMetricName}
                      onChange={e => {
                        this.setState({
                          editMetricName: e.target.value,
                        });
                      }}
                    />
                    {this.state.formErrors.editMetricNameError && (
                      <div className="invalid-tooltip d-block" style={{ marginTop: "-35px" }}>
                        {constants.FORM.MANDATORY_FIELD}
                      </div>
                    )}
                  </div>
                  <div style={{ width: "30%" }}>
                    <input
                      min={1}
                      max={100}
                      type="number"
                      name="priority"
                      value={this.state.editPriority}
                      placeholder="Enter Priority"
                      className={`form-control`}
                      onChange={e => {
                        this.setState({
                          editPriority: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              ) : (
                this.state.metricsArray.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="d-flex g-10 justify-content-between"
                      style={{
                        padding: "0px 16px",
                        width: "100%",
                        marginBottom: "10px",
                      }}
                    >
                      <div style={{ width: "70%" }}>
                        <input
                          type="text"
                          name="metricName"
                          placeholder="Enter Metric Name"
                          className={`form-control ${
                            this.state.formErrors.metricsArrayError && item.name.trim() === "" ? "is-invalid" : ""
                          }`}
                          value={item.name}
                          onChange={e => {
                            this.setState({
                              metricsArray: this.state.metricsArray.map((metric, metricIndex) =>
                                metricIndex === index ? { ...metric, name: e.target.value } : metric,
                              ),
                            });
                          }}
                        />
                      </div>
                      <div style={{ width: "30%" }}>
                        <input
                          min={1}
                          max={100}
                          type="number"
                          name="priority"
                          value={item.priority}
                          placeholder="Enter Priority"
                          className={`form-control`}
                          onChange={e => {
                            this.setState({
                              metricsArray: this.state.metricsArray.map((metric, metricIndex) =>
                                metricIndex === index ? { ...metric, priority: e.target.value } : metric,
                              ),
                            });
                          }}
                        />
                      </div>

                      {index > 0 && (
                        <img
                          src={"https://tbr-ggk.s3.us-east-2.amazonaws.com/development%20/RemoveIcon.svg"}
                          style={{ width: "20px", cursor: "pointer" }}
                          onClick={() => {
                            this.setState({
                              metricsArray: this.state.metricsArray.filter((_, key) => key !== index),
                            });
                          }}
                          alt="remove-icon"
                        />
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </ModalBody>
          <ModalFooter className={"add-category-model-footer"} style={{ marginTop: "-15px" }}>
            {!this.state.metricId ? (
              <Button
                className={"btn-outline-primary modal-btn add-btn"}
                onClick={() =>
                  this.setState({
                    metricsArray: [...this.state.metricsArray, { name: "", priority: 100 }],
                  })
                }
              >
                + Add More
              </Button>
            ) : null}
            <Button
              className={"modal-right-btn modal-btn"}
              // disabled={saveButton || firstTime}
              type="submit"
              onClick={e => {
                this.state.isEdit ? this.handleEditSubmit(e, this.state.metricId) : this.handleSubmit(e);
              }}
            >
              {this.state.metricId ? "Update" : "Save"}
            </Button>
          </ModalFooter>
        </Modal>
        <DialogNew
          isOpen={this.state.dialogModal}
          accept={this.dialogModalAccept}
          decline={this.dialogModalDecline}
          header={this.state.dialogModalHeader}
          content={this.state.dialogModalContent}
          config={this.state.dialogModalConfig}
          modalStyleType={this.state.dialogModalStyleType}
        />
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    home: state.home,
  };
};

export default connect(mapStateToProps, null)(ListMetrics);
